<div fxLayout="column" fxLayoutGap="15px" [formGroup]="passwordForm">
  <div fxLayout="row">
    <h3>Zmiana hasła</h3>
  </div>

  <div fxLayout="row">
    <mat-form-field fxFlex="100">
      <mat-label>Aktualne hasło</mat-label>
      <input type="password" matInput placeholder="Aktualne hasło" formControlName="currentPassword" [required]="true">
      <mat-error *ngIf="passwordForm.get('currentPassword').hasError('required')">To pole jest wymagane</mat-error>
      <mat-error *ngIf="passwordForm.get('currentPassword').hasError('backendError')">{{formErrors.currentPassword}}</mat-error>
    </mat-form-field>
  </div>

  <div fxLayout="row">
    <mat-form-field fxFlex="100">
      <mat-label>Nowe hasło</mat-label>
      <input type="password" matInput placeholder="Nowe hasło" formControlName="newPassword" [required]="true">
      <mat-error *ngIf="passwordForm.get('newPassword').hasError('required')">To pole jest wymagane</mat-error>
      <mat-error *ngIf="passwordForm.get('newPassword').hasError('backendError')">{{formErrors.newPassword}}</mat-error>
    </mat-form-field>
  </div>

  <div fxLayout="row">
    <h4>Hasło musi zawierać:</h4>
  </div>

  <div fxLayout="row" class="password-requirements">
    <div class="password-requirement-error" fxFlex="30px" *ngIf="!passwordForm.get('newPassword').value || passwordForm.get('newPassword').hasError('minlength')">
      <mat-icon>error_outline</mat-icon>
    </div>
    <div class="password-requirement-ok" fxFlex="30px" *ngIf="passwordForm.get('newPassword').value && !passwordForm.get('newPassword').hasError('minlength')">
      <mat-icon>check_circle_outline</mat-icon>
    </div>
    <span fxFlex>co najmniej 12 znaków</span>
  </div>

  <div fxLayout="row" class="password-requirements">
    <div class="password-requirement-error" fxFlex="30px" *ngIf="!passwordForm.get('newPassword').value || passwordForm.get('newPassword').hasError('twoCapitalLetters')">
      <mat-icon>error_outline</mat-icon>
    </div>
    <div class="password-requirement-ok" fxFlex="30px" *ngIf="passwordForm.get('newPassword').value && !passwordForm.get('newPassword').hasError('twoCapitalLetters')">
      <mat-icon>check_circle_outline</mat-icon>
    </div>
    <span fxFlex>co najmniej dwie wielkie litery</span>
  </div>

  <div fxLayout="row" class="password-requirements">
    <div class="password-requirement-error" fxFlex="30px" *ngIf="!passwordForm.get('newPassword').value || passwordForm.get('newPassword').hasError('twoSmallLetters')">
      <mat-icon>error_outline</mat-icon>
    </div>
    <div class="password-requirement-ok" fxFlex="30px" *ngIf="passwordForm.get('newPassword').value && !passwordForm.get('newPassword').hasError('twoSmallLetters')">
      <mat-icon>check_circle_outline</mat-icon>
    </div>
    <span fxFlex>co najmniej dwie małe litery</span>
  </div>

  <div fxLayout="row" class="password-requirements">
    <div class="password-requirement-error" fxFlex="30px" *ngIf="!passwordForm.get('newPassword').value || passwordForm.get('newPassword').hasError('oneDigit')">
      <mat-icon>error_outline</mat-icon>
    </div>
    <div class="password-requirement-ok" fxFlex="30px" *ngIf="passwordForm.get('newPassword').value && !passwordForm.get('newPassword').hasError('oneDigit')">
      <mat-icon>check_circle_outline</mat-icon>
    </div>
    <span fxFlex>co najmniej jedną cyfrę</span>
  </div>

  <div fxLayout="row" class="password-requirements">
    <div class="password-requirement-error" fxFlex="30px" *ngIf="!passwordForm.get('newPassword').value || passwordForm.get('newPassword').hasError('oneSpecialChar')">
      <mat-icon>error_outline</mat-icon>
    </div>
    <div class="password-requirement-ok" fxFlex="30px" *ngIf="passwordForm.get('newPassword').value && !passwordForm.get('newPassword').hasError('oneSpecialChar')">
      <mat-icon>check_circle_outline</mat-icon>
    </div>
    <span fxFlex>co najmniej jeden ze znaków specjalnych: !@#$%^&*()-_=+{{'{}'}};:,<.></span>
  </div>

  <div fxLayout="row">
    <mat-form-field fxFlex="100">
      <mat-label>Powtórz hasło</mat-label>
      <input type="password" matInput placeholder="Powtórz hasło" formControlName="repeatPassword" [required]="true">
      <mat-error *ngIf="passwordForm.get('repeatPassword').hasError('required')">To pole jest wymagane</mat-error>
      <mat-error *ngIf="passwordForm.get('repeatPassword').hasError('invalidRepeatedPassword')">Podaj taką samą wartość</mat-error>
      <mat-error *ngIf="passwordForm.get('repeatPassword').hasError('backendError')">{{formErrors.repeatPassword}}</mat-error>
    </mat-form-field>
  </div>

  <div fxLayout="row">
    <button (click)="sendForm()" [class.spinner]="processingRequest" [disabled]="processingRequest || !enableSaveButton"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>

  </div>
</div>
